"use client";
import * as React from "react";
const SvgCallFilled = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M15.12 11.004c-1.093 0-2.151-.177-3.138-.497a.869.869 0 0 0-.898.213L9.69 12.471c-2.516-1.2-4.871-3.467-6.125-6.071l1.734-1.476a.907.907 0 0 0 .213-.906A9.913 9.913 0 0 1 5.013.88c0-.48-.4-.88-.88-.88H1.058C.578 0 0 .213 0 .88 0 9.138 6.871 16 15.12 16c.631 0 .88-.56.88-1.049v-3.067c0-.48-.4-.88-.88-.88Z" }));
export {
  SvgCallFilled as default
};
